import { useEffect as r, useRef as n } from "react";
export default function (t, e) {
  var u = n();
  r(function () {
    u.current = t;
  }, [t]), r(function () {
    if (null !== e) {
      var r = setInterval(function () {
        for (var r = [], n = arguments.length; n--;) r[n] = arguments[n];

        return u.current.apply(u, r);
      }, e);
      return function () {
        return clearInterval(r);
      };
    }
  }, [e]);
}